import { render, staticRenderFns } from "./RateForm.vue?vue&type=template&id=08012a98"
import script from "./RateForm.vue?vue&type=script&lang=js"
export * from "./RateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports